// frontend/src/components/AuthOnboardLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import { OnboardingProvider } from '../contexts/OnboardingContext';
import { SyncProvider } from '../contexts/SyncContext';

/**
 * Layout for all authenticated + onboarding routes.
 * Applies OnboardingProvider and SyncProvider once, then renders children via Outlet.
 */
export default function AuthOnboardLayout() {
  return (
    <OnboardingProvider>
      <SyncProvider>
        <Outlet />
      </SyncProvider>
    </OnboardingProvider>
  );
}